import { faCheck, faTimes } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Avatar, ListItem, ListItemAvatar, ListItemText } from "@mui/material"
import { styled } from "@mui/material/styles"

const sharedStyle = {
  width: "24px",
  height: "24px",
  "& span": {
    opacity: 1
  }
}
const StyledAvatar = styled(Avatar)(sharedStyle)
const StyledGreenAvatar = styled(StyledAvatar)(({ theme }) => ({
  background: theme.palette.success["light"],
  color: theme.palette.success["dark"]
}))
const StyledRedAvatar = styled(StyledAvatar)(({ theme }) => ({
  background: theme.palette.error["light"],
  color: theme.palette.error["dark"]
}))

const GreenCheck = () => (
  <StyledGreenAvatar>
    <FontAwesomeIcon icon={faCheck} size={"xs"} />
  </StyledGreenAvatar>
)

const RedCrossSign = () => (
  <StyledRedAvatar>
    <FontAwesomeIcon icon={faTimes} size={"xs"} />
  </StyledRedAvatar>
)

const getColor = (theme, item) => {
  if (item.isAnswered) {
    return item.isCorrectAnswer
      ? {
          background: theme.palette.success.light,
          color: theme.palette.success.dark
        }
      : {
          background: theme.palette.error.light,
          color: theme.palette.error.dark
        }
  }
}

const StyledListItem = styled(ListItem)(({ theme, item }) => ({
  ...getColor(theme, item),
  borderRadius: 5,
  "& span": {
    opacity: 0.5
  }
}))

export const Option = (props) => {
  const { item } = props

  return (
    <StyledListItem item={item}>
      <ListItemText primary={item.label} />

      {item.isCorrectAnswer && (
        <ListItemAvatar>
          <GreenCheck />
        </ListItemAvatar>
      )}
      {!item.isCorrectAnswer && item.isAnswered && (
        <ListItemAvatar>
          <RedCrossSign />
        </ListItemAvatar>
      )}
    </StyledListItem>
  )
}
